<template>
    <div class="get-app-view">
        <div class="phone-icon-container">
            <div class="phone-icon">
                <img src="/smartphone-icon.svg" alt="Smart Phone Image" class="phone" />
                <img src="pc_logo_stacked.png" class="logo" />
            </div>
            <div class="phone-info">
                <p>Download the PlayerConnect mobile app from the app store</p>
                <div class="download-badge">
                    <a href="https://apps.apple.com/us/app/gs-playerconnect/id6741215463">
                        <img src="/appstore_badge.svg" />
                    </a>
                </div>
                <div class="download-badge">
                    <a href="https://play.google.com/store/apps/details?id=com.PlayerConnectMobile&utm_source=na_Med">
                        <img src="/googleplay_badge.svg" />
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

</script>

<style>
    @import '/src/assets/css/getAppView.css';   
</style>